import React from 'react';
import Link from '../../Link/Link';
import {InfiosHeaderMetaNav} from './HeaderMetaNav.style';

const HeaderMetaNav = props => {
    const { className, content, blackLetter, isMobile } = props;


    return (
        <>
            {content && <InfiosHeaderMetaNav isMobile={isMobile} data-analytics="header" className={className} blackLetter={blackLetter}>
                {
                    content.map(({textLink, urlLink, targetLink}, index) => {
                        return (
                            <React.Fragment key={`keyMetaNav-${index}`}>
                                <Link className="label-medium" link={urlLink} target={targetLink} noIcon text={textLink} />
                            </React.Fragment>
                        )

                    })
                }
            </InfiosHeaderMetaNav>}
        </>
    )
}

export default HeaderMetaNav
